import { useOrganizationStore } from "../store/useOrganizationStore";
import { useSuperAdmin } from "./useSuperAdmin";

export function useOrgRole() {
  const { currentUserRole, activeOrgId, isRoleLoading } =
    useOrganizationStore();
  const { isSuperAdmin, isChecking } = useSuperAdmin();

  const canEdit =
    isSuperAdmin ||
    currentUserRole === "editor" ||
    currentUserRole === "admin" ||
    currentUserRole === "member";

  /** Any org member (including viewer) can create new SOPs. */
  const canCreateSOP =
    isSuperAdmin ||
    currentUserRole === "editor" ||
    currentUserRole === "admin" ||
    currentUserRole === "member" ||
    currentUserRole === "viewer";

  /** Any org member can access RMA analysis (upload images, run analysis, view results). */
  const canAccessRMA =
    isSuperAdmin ||
    currentUserRole === "editor" ||
    currentUserRole === "admin" ||
    currentUserRole === "member" ||
    currentUserRole === "viewer";

  /** Editor+ can download SOPs (PDF/Markdown export). */
  const canDownload =
    isSuperAdmin ||
    currentUserRole === "editor" ||
    currentUserRole === "admin";

  /** RMA dataset management: editor+ only. */
  const canManageRMA =
    isSuperAdmin ||
    currentUserRole === "editor" ||
    currentUserRole === "admin";

  /** Review queue, publish to org, edit AI rows before publish: super_admin only. */
  const canPublishRMA = isSuperAdmin;

  const canManageMembers = isSuperAdmin || currentUserRole === "admin";

  /** Admin+ can resolve and delete feedback. */
  const canManageFeedback = isSuperAdmin || currentUserRole === "admin";

  const isRoleResolving = isRoleLoading || isChecking;

  return {
    currentUserRole,
    canEdit,
    canCreateSOP,
    canAccessRMA,
    canDownload,
    canManageRMA,
    canPublishRMA,
    canManageMembers,
    canManageFeedback,
    activeOrgId,
    isRoleResolving,
  };
}
